<template>
  <v-container>
    <loading
      :active.sync="loading"
      background-color="#C5CAE9"
      color="#1A237E"
      :is-full-page="false"
    ></loading>
    <v-row>
      <v-col cols="12" sm="12">
        <base-material-card color="indigo darken-4" icon="mdi-calendar-multiple">
          <template v-slot:after-heading>
            <base-v-component heading="Ventas anuales por mes"/>
          </template>
          <v-container>
            <v-row no-gutters>
              <v-col cols="12" sm="6" md="3" lg="4" xl="2"></v-col>
              <v-col cols="12" sm="6" md="9" lg="8" xl="10">
                <v-layout row wrap justify-end>
                  <!-- Branch Office -->
                  <v-col cols="12" sm="12" md="5" lg="6" xl="4">
                    <v-select :items="BranchOffice" v-model="BranchOfficeId" item-value="id" item-text="name"
                      return-object dense clearable color="indigo darken-4" label="Todas las Oficinas">
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" xl="2">
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="startDate" label="Fecha inicial" color="indigo darken-4"
                          append-icon="mdi-calendar-multiselect" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="es" :max="finishDate" color="indigo darken-3"
                        v-model="startDate" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" xl="2">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="finishDate" label="Fecha Final"
                          append-icon="mdi-calendar-multiselect" readonly v-on="on"/>
                      </template>
                      <v-date-picker locale="es" :min="startDate" color="indigo darken-3" v-model="finishDate" @input="menu2 = false"/>
                    </v-menu>
                  </v-col>
                </v-layout>
              </v-col>
            </v-row>
          </v-container>
        </base-material-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import XLSX from "xlsx";
import Swal from "sweetalert2";
import "vue-loading-overlay/dist/vue-loading.css";
moment.locale("es");
export default {
  components: {
    Loading: () => import("vue-loading-overlay"),
  },

  data: () => ({
    isLoading: false,
    search: null,
    loading: false,
    headers: [],
    menu: false,
    menu2: false,
    BranchOfficeId: null,
    finishDate: moment().endOf("month").format("YYYY-MM-DD"),
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
  }),
  computed: {
    BranchOffice() {
      return this.$store.state.BranchOffice;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
